/* ---------- Botão X do menu lateral (somente mobile) ---------- */
(function() {
  if (window.innerWidth > 749) return;

  var btn = document.createElement('button');
  btn.id = 'gk-menu-close-btn';
  btn.setAttribute('aria-label', 'Fechar menu');
  btn.innerHTML = '&#x2715;';
  btn.style.cssText = 'position:fixed;top:50px;right:33px;z-index:99999;width:30px;height:30px;border-radius:50%;background:#F45B69;color:#fff;border:none;font-size:1rem;line-height:1;display:none;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 2px 6px rgba(0,0,0,0.2);';
  document.body.appendChild(btn);

  function mostrar() { btn.style.display = 'flex'; }
  function esconder() { btn.style.display = 'none'; }

  btn.addEventListener('click', function() {
    var details = document.getElementById('Details-menu-drawer-container');
    if (details) details.removeAttribute('open');
    var nativeClose = document.querySelector('.menu-drawer__close-button');
    if (nativeClose) nativeClose.click();
    document.dispatchEvent(new CustomEvent('header-drawer/close'));
    esconder();
  });

  function observar() {
    var details = document.getElementById('Details-menu-drawer-container');
    if (!details) { setTimeout(observar, 300); return; }

    var obs = new MutationObserver(function() {
      if (details.hasAttribute('open')) mostrar(); else esconder();
    });
    obs.observe(details, { attributes: true, attributeFilter: ['open'] });

    var bodyObs = new MutationObserver(function() {
      if (document.body.classList.contains('menu-open')) mostrar(); else esconder();
    });
    bodyObs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observar);
  } else {
    observar();
  }
})();


/* ---------- Etiqueta de cupom clicável na página do produto ---------- */
(function() {
  var TEXTO_ALVO = 'com o cupom';
  var ICONE = '<svg class="gk-cupom__icone" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="9" width="13" height="13" rx="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>';

  function montar() {
    var paragrafos = document.querySelectorAll('p');

    for (var i = 0; i < paragrafos.length; i++) {
      var p = paragrafos[i];
      var texto = (p.textContent || '').trim();

      if (texto.indexOf(TEXTO_ALVO) === -1) continue;
      if (p.querySelector('.gk-cupom')) continue;
      // GK: o aviso do cupom PIX no carrinho fica como texto simples
      if (p.closest('.gk-dica-pix')) continue;

      var partes = texto.split(/\s+/);
      var codigo = partes[partes.length - 1];
      if (!codigo) continue;

      var prefixo = texto.slice(0, texto.lastIndexOf(codigo)).trim();

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gk-cupom';
      btn.setAttribute('data-cupom', codigo);
      btn.setAttribute('aria-label', 'Copiar cupom ' + codigo);
      btn.setAttribute('title', 'Clique para copiar');
      btn.innerHTML =
        '<span class="gk-cupom__label">' + prefixo + ' <strong>' + codigo + '</strong></span>' +
        ICONE +
        '<span class="gk-cupom__feito">Cupom copiado!</span>';

      p.textContent = '';
      p.appendChild(btn);
    }
  }

  function avisarCopiado(btn) {
    btn.classList.add('gk-cupom--copiado');
    setTimeout(function() { btn.classList.remove('gk-cupom--copiado'); }, 1800);
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest ? e.target.closest('.gk-cupom') : null;
    if (!btn) return;

    e.preventDefault();
    var codigo = btn.getAttribute('data-cupom') || '';

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(codigo).then(function() {
        avisarCopiado(btn);
      }).catch(function() {});
      return;
    }

    var campo = document.createElement('textarea');
    campo.value = codigo;
    campo.setAttribute('readonly', '');
    campo.style.cssText = 'position:fixed;top:0;left:0;opacity:0;';
    document.body.appendChild(campo);
    campo.select();
    campo.setSelectionRange(0, codigo.length);
    try {
      document.execCommand('copy');
      avisarCopiado(btn);
    } catch (err) {}
    document.body.removeChild(campo);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', montar);
  } else {
    montar();
  }

  document.addEventListener('variant:update', montar);
  document.addEventListener('cart:update', montar);
})();


/* ---------- Campo de cupom do carrinho sempre aberto ---------- */
(function() {
  function abrirDesconto() {
    var blocos = document.querySelectorAll('details.discount-details');

    for (var i = 0; i < blocos.length; i++) {
      var d = blocos[i];

      if (!d.open) d.open = true;

      if (d.getAttribute('data-gk-fixo') === '1') continue;
      d.setAttribute('data-gk-fixo', '1');

      // Se algo tentar fechar, reabre
      d.addEventListener('toggle', function() {
        if (!this.open) this.open = true;
      });

      // Clique no cabeçalho não fecha mais
      var resumo = d.querySelector('summary');
      if (resumo) {
        resumo.addEventListener('click', function(e) {
          e.preventDefault();
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', abrirDesconto);
  } else {
    abrirDesconto();
  }

  // O carrinho é re-renderizado ao adicionar/remover itens
  var obs = new MutationObserver(function() { abrirDesconto(); });
  obs.observe(document.body, { childList: true, subtree: true });
})();
